import {defineStore} from 'pinia'
import {IAlertStoreState} from './types/IAlertStoreState'
import {$ref} from '@vue-macros/reactivity-transform/macros'

export const useAlertStore = defineStore('errorPage', {
  state: () => {
    return {
      isOpen: false,
      dismissTimeoutId: null,
      payload: {
        message: '',
        description: '',
        color: 'success',
        duration: 0,
        isCentered: false,
        layout: 'horizontal',
        buttons: [],
        inputValue: '',
        showInput: false,
        iconNameType: undefined,
        iconWeightType: undefined,
        iconColor: 'primary',
        showCover: false,
        position: 'top-center',
      },
    } as IAlertStoreState
  },
  actions: {
    open(
      payload: Partial<IAlertStoreState['payload']>,
    ) {
      this.setDefaultPayload()
      this.payload.inputValue = ''
      this.isOpen = true
      const newButtons = $ref(payload?.buttons)
      this.payload = {
        ...this.payload,
        ...payload,
        buttons: newButtons || [],
      }
      /**
       * The previous alert's pending timer must die with it — left running, a short-lived toast's
       * timeout would auto-dismiss whatever alert replaced it, a consent dialog included.
       */
      if(this.dismissTimeoutId) {
        clearTimeout(this.dismissTimeoutId)
        this.dismissTimeoutId = null
      }
      if(!payload.duration) return
      this.dismissTimeoutId = setTimeout(() => {
        this.isOpen = false
        this.dismissTimeoutId = null
      }, payload.duration)
    },
    close() {
      this.isOpen = false
      if(this.dismissTimeoutId) {
        clearTimeout(this.dismissTimeoutId)
        this.dismissTimeoutId = null
      }
    },
    setInput (value: string) {
      this.payload.inputValue = value
    },
    setDefaultPayload() {
      this.payload = {
        message: '',
        description: '',
        color: 'success',
        duration: 0,
        isCentered: false,
        layout: 'horizontal',
        buttons: [],
        inputValue: '',
        showInput: false,
        iconNameType: undefined,
        iconWeightType: undefined,
        iconColor: 'primary',
        showCover: false,
        position: 'top-center',
      }
    },
  },
})

